import Vue from "vue";
import store from "./store";
import router from "./router";
import App from "./components/App";

import Element from "./utils/register-element-ui";
import "@/assets/css/font.css";

import VueBMap from "vue-bmap-gl";
import "vue-bmap-gl/dist/style.css";
Vue.use(VueBMap);
VueBMap.initBMapApiLoader({
  ak: "pG1uKRvfwV1qiiuHjzAdhtKcv0z9EQoK",
  v: "2.0"
});

new Vue({
  router,
  store,
  template: "<App/>",
  components: { App }
}).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js